import templateUrl from './string.tpl.html';

angular
    .module('festzelt-os.components')
    .component('filterString', {
        bindings: {
            store: '<',
            col: '<',
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/types/filter-type-string.js